{
  "jsm-nebula.jsm-kb-activation-reminder.add-knowledge-from-third-party-apps": [
    {
      "type": 0,
      "value": "Add knowledge from third-party apps"
    }
  ],
  "jsm-nebula.jsm-kb-activation-reminder.boost-agent-productivity": [
    {
      "type": 0,
      "value": "Boost agent productivity"
    }
  ],
  "jsm-nebula.jsm-kb-activation-reminder.create-or-link-articles": [
    {
      "type": 0,
      "value": "Create or link articles."
    }
  ],
  "jsm-nebula.jsm-kb-activation-reminder.empower-customers-with-instant-access": [
    {
      "type": 0,
      "value": "Empower customers with instant access to helpful articles"
    }
  ],
  "jsm-nebula.jsm-kb-activation-reminder.get-started-button-label": [
    {
      "type": 0,
      "value": "Get started"
    }
  ],
  "jsm-nebula.jsm-kb-activation-reminder.getting-started-is-easy": [
    {
      "type": 0,
      "value": "Getting started is easy"
    }
  ],
  "jsm-nebula.jsm-kb-activation-reminder.greeting-message": [
    {
      "type": 0,
      "value": "Hi "
    },
    {
      "type": 1,
      "value": "name"
    },
    {
      "type": 0,
      "value": ","
    }
  ],
  "jsm-nebula.jsm-kb-activation-reminder.header.text": [
    {
      "type": 0,
      "value": "Say goodbye to knowledge silos"
    }
  ],
  "jsm-nebula.jsm-kb-activation-reminder.how-to-set-up-your-knowledge-base": [
    {
      "type": 0,
      "value": "How to set up your knowledge base"
    }
  ],
  "jsm-nebula.jsm-kb-activation-reminder.illustration.alt": [
    {
      "type": 0,
      "value": "KnowledgeBase Illustration"
    }
  ],
  "jsm-nebula.jsm-kb-activation-reminder.improve-ai-powered-suggestions": [
    {
      "type": 0,
      "value": "Improve AI-powered suggestions"
    }
  ],
  "jsm-nebula.jsm-kb-activation-reminder.improve-knowledge-base-health-by-closing-knowledge-gaps": [
    {
      "type": 0,
      "value": "Improve knowledge base health by closing knowledge gaps."
    }
  ],
  "jsm-nebula.jsm-kb-activation-reminder.knowledge-base-benefit": [
    {
      "type": 0,
      "value": "By setting up a knowledge base, you can provide instant answers to your customers, reduce repetitive requests, and help your team resolve requests faster."
    }
  ],
  "jsm-nebula.jsm-kb-activation-reminder.knowledge-base-help": [
    {
      "type": 0,
      "value": "Adding knowledge to your Jira Service Management project helps:"
    }
  ],
  "jsm-nebula.jsm-kb-activation-reminder.message-template.email.subject": [
    {
      "type": 0,
      "value": "[Jira Service Management] Set up your knowledge base today"
    }
  ],
  "jsm-nebula.jsm-kb-activation-reminder.need-help-explore-these-resources": [
    {
      "type": 0,
      "value": "Need help? Explore these resources"
    }
  ],
  "jsm-nebula.jsm-kb-activation-reminder.privacy-policy": [
    {
      "type": 0,
      "value": "Privacy policy"
    }
  ],
  "jsm-nebula.jsm-kb-activation-reminder.project-notice": [
    {
      "type": 0,
      "value": "We noticed your Jira Service Management project, "
    },
    {
      "children": [
        {
          "type": 1,
          "value": "project"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": ", doesn't have a knowledge base yet."
    }
  ],
  "jsm-nebula.jsm-kb-activation-reminder.sent-to-you-by-atlassian-jira-service-management": [
    {
      "type": 0,
      "value": "Sent to you by Atlassian Jira Service Management  •"
    }
  ],
  "jsm-nebula.jsm-kb-activation-reminder.share-them-with-your-team-and-customers": [
    {
      "type": 0,
      "value": "Share them with your team and customers."
    }
  ],
  "jsm-nebula.jsm-kb-activation-reminder.start-building-your-knowledge-base": [
    {
      "type": 0,
      "value": "Start building your knowledge base"
    }
  ],
  "jsm-nebula.jsm-kb-activation-reminder.stay-notified-and-comment-on-the-go-with-jira-mobile-app": [
    {
      "type": 0,
      "value": "Stay notified and comment on the go with Jira Mobile App"
    }
  ],
  "jsm-nebula.jsm-kb-activation-reminder.subheading": [
    {
      "type": 0,
      "value": "Set up knowledge base to keep requests and knowledge within Jira Service Management."
    }
  ],
  "jsm-nebula.jsm-kb-activation-reminder.surface-instant-answers-deflect-requests-and-keep-everything-in-one-place": [
    {
      "type": 0,
      "value": "Surface instant answers, deflect requests, and keep everything in one place"
    }
  ],
  "jsm-nebula.jsm-kb-activation-reminder.tips-for-writing-effective-knowledge-articles": [
    {
      "type": 0,
      "value": "Tips for writing effective knowledge articles"
    }
  ],
  "jsm-nebula.jsm-kb-activation-reminder.to-build-your-knowledge-base": [
    {
      "type": 0,
      "value": "To build your knowledge base, all you need to do is:"
    }
  ],
  "jsm-nebula.jsm-kb-activation-reminder.to-customize-email-or-unsubscribe": [
    {
      "type": 0,
      "value": "To customize the email or unsubscribe, "
    }
  ],
  "jsm-nebula.jsm-kb-activation-reminder.update-your-notification-settings": [
    {
      "type": 0,
      "value": "update your notification settings."
    }
  ],
  "jsm-nebula.jsm-kb-activation-reminder.why-set-up-knowledge-base": [
    {
      "type": 0,
      "value": "Why set up a knowledge base?"
    }
  ]
}